const phi = (5 ** 0.5 + 1) * 0.5;

export function nthSunflowerColour(n, s = 80, l = 50) {
	return `hsl(${((phi * n) % 1) * 360}deg, ${s}%, ${l}%)`;
}

export function isDark(colour) {
	if (/^#[0-9a-f]{6}$/.test(colour)) {
		return parseInt(colour.substr(3, 2), 16) < 145;
	}
	if (/^hsl\([\d.]+deg, \d+%, \d+%\)$/.test(colour)) {
		const l = parseFloat(colour.split(',')[2]);
		if (l > 75) return false;
		const hue = parseFloat(colour.substr(4));
		return hue > 180 || hue < 30;
	}
	console.warn('Unexpected colour format found:', colour);
	return false;
}
